export const ROLES = {
    SUPER_ADMIN: 'super-admin',
    ADMIN: 'admin',
    EMPRESA: 'empresa',
    APLICADOR: 'aplicador',
};
